import ProductCard from '../productCard/productCard';
import noProductsLottie from "../../assets/lotties/no-products-found.json";
import noSearchLottie from "../../assets/lotties/search empty.json";
import loadingLottie from "../../assets/lotties/loading.json";
import './productList.css';
import Lottie from 'lottie-react';

export default function ProductList({ products, loading, isSearch = false }) {
  if (loading) {
    return (
      <div className="productList-lottie-wrapper">
        <Lottie
          animationData={loadingLottie}
          loop
          autoplay
          className="productList-lottie"
        />
      </div>
    );
  }

  if (!products || products.length === 0) {
    return (
      <div className="productList-lottie-wrapper">
        <Lottie
          animationData={isSearch ? noSearchLottie : noProductsLottie}
          loop
          autoplay
          className="productList-lottie-notFound"
        />
        <p className="productList-no-products">
          {isSearch ? 'No search results found.' : 'No products found.'}
        </p>
      </div>
    );
  }

  return (
    <>
      <h2 className="productList-title">{isSearch ? 'Search Results' : 'Products'}</h2>
      <div className="productList-list">
        {products.map((product) => (
          <ProductCard key={product._id || product.id} product={product} />
        ))}
      </div>
    </>
  );
}
